import "./Contact.css";
import "../../styles/App.css";
import Navbar from "../../components/Navbar/Navbar.js";
import Footer from "../../components/Footer/Footer.js";


function Contact() {
    return(
        <div className="Contact-Page">
            <Navbar />
            <h1 className="heading">Contact Page</h1>
            <p>Welcome to the Contact Page!</p>

            <Footer />
        </div>
    );
}

export default Contact;